import React from "react";
import parse from "html-react-parser";

/**
 * Convert nodes that use `dangerouslySetInnerHTML` to use `children` instead
 * This is because helmet ignores dangerouslySetInnerHTML attributes but seems to
 * use dangerouslySetInnerHTML itself when adding styles, scripts and markup
 */
const convertDangerousHtmlToChildren = node => {
    if (node?.props?.dangerouslySetInnerHTML) {
        return {
            ...node,
            props: {
                ...node.props,
                children: node.props.dangerouslySetInnerHTML.__html,
            },
        };
    }
    return node;
};

export const getHeadTrackingTags = (headTrackingTags) => {
    try {
        const parsedHeadTags = parse(headTrackingTags.replace(/\n/g, ""));
        const arrayHeadTags = Array.isArray(parsedHeadTags) ? parsedHeadTags : [parsedHeadTags];
        return arrayHeadTags.map(item => convertDangerousHtmlToChildren(item));
    } catch (error) {
        console.warn("trackingTags: error retrieving/parsing headTrackingTags");
        return <meta name="parseHeadTrackingTags" content="failed" />;
    }
};

export const getBodyTrackingTags = (bodyTrackingTags) => {
    try {
        return parse(bodyTrackingTags.replace(/\n/g, ""));
    } catch (error) {
        console.warn("trackingTags: error retrieving/parsing bodyTrackingTags");
        return <div style={{display: "none"}}>parseBodyTrackingTags failed</div>;
    }
};